import { HttpParams } from '@angular/common/http';

/**
 * Classe permettant de faire passer une string custom avec une requête http, qui sert au LogInterceptor
 * pour afficher les logs.
 * params correspond aux paramètres initiaux de la requête.
 */
export class EasiHttpParams extends HttpParams {
    constructor(args: {
        log?: string;
        params?: { [param: string]: any | any[] };
        noError?: boolean;
        noCredentials?: boolean;
        overrideBaseUrl?: boolean;
    }) {
        super({ fromObject: args.params });
        if (args.log) {
            this.log = args.log;
        }
        if (args.noError === true) {
            this.noError = args.noError;
        }
        if (args.noCredentials) {
            this.noCredentials = args.noCredentials;
        }
        if (args.overrideBaseUrl) {
            this.overrideBaseUrl = args.overrideBaseUrl;
        }
    }
    log: string;
    noError = false;
    noCredentials = false;
    overrideBaseUrl = false;
}
